import { Link } from 'react-router-dom';
import { Facebook, Instagram, Mail, Phone, Smartphone, Youtube } from 'lucide-react';

const Footer = () => {
  return (
    <footer className='bg-muted/50 border-t border-border mt-20 hidden md:block'>
      <div className='container mx-auto px-4 py-12'>
        <div className='grid grid-cols-1 md:grid-cols-4 gap-8'>
          <div>
            {/* <h3 className="font-semibold mb-4 text-sm uppercase tracking-wide">Follow Us</h3> */}
            <ul className='space-y-2'>
              <li>
                <Link
                  to='https://www.facebook.com/schrammekmongolia'
                  target='_blank'
                  className='text-sm text-muted-foreground hover:text-primary transition-colors flex items-center'
                >
                  <Facebook className='w-4 h-4 mr-2' />
                  Facebook
                </Link>
              </li>
              <li>
                <Link
                  to='https://www.instagram.com/schrammekmongolia'
                  target='_blank'
                  className='text-sm text-muted-foreground hover:text-primary transition-colors flex items-center'
                >
                  <Instagram className='w-4 h-4 mr-2' />
                  Instagram
                </Link>
              </li>
              <li>
                <Link
                  to='https://www.youtube.com/@zayaschannel533'
                  target='_blank'
                  className='text-sm text-muted-foreground hover:text-primary transition-colors flex items-center'
                >
                  <Youtube className='w-4 h-4 mr-2' />
                  Youtube
                </Link>
              </li>
            </ul>
          </div>

          {/* <div>
            <h3 className="font-semibold mb-4 text-sm uppercase tracking-wide">Company</h3>
            <ul className="space-y-2">
              <li>
                <Link to="#" className="text-sm text-muted-foreground hover:text-primary transition-colors">
                  About Us
                </Link>
              </li>
              <li>
                <Link to="#" className="text-sm text-muted-foreground hover:text-primary transition-colors">
                  Privacy Policy
                </Link>
              </li>
              <li>
                <Link to="#" className="text-sm text-muted-foreground hover:text-primary transition-colors">
                  Terms of Service
                </Link>
              </li>
            </ul>
          </div> */}

          <div>
            {/* <h3 className="font-semibold mb-4 text-sm uppercase tracking-wide">Need Help?</h3> */}
            <ul className='space-y-2'>
              <li>
                <Link
                  to='tel:77074006'
                  className='text-sm text-muted-foreground hover:text-primary transition-colors flex items-center'
                >
                  <Phone className='w-4 h-4 mr-2' />
                  +976 77074006
                </Link>
              </li>
              <li>
                <Link
                  to='tel:98004006'
                  className='text-sm text-muted-foreground hover:text-primary transition-colors flex items-center'
                >
                  <Smartphone className='w-4 h-4 mr-2' />
                  +976 98004006
                </Link>
              </li>
              <li>
                <Link
                  to='mailto:hidesan.com.ltd@gmail.com'
                  className='text-sm text-muted-foreground hover:text-primary transition-colors flex items-center'
                >
                  <Mail className='w-4 h-4 mr-2' />
                  hidesan.com.ltd@gmail.com
                </Link>
              </li>
            </ul>
          </div>

          <div>
            {/* <h3 className="font-semibold mb-4 text-sm uppercase tracking-wide">Contact</h3> */}
            <p className='text-sm text-muted-foreground mb-2'>
              Dr. med. Christine Schrammek Kosmetik GmbH
            </p>
            {/* <p className='text-sm text-muted-foreground'>
              Email: info@schrammek.com
            </p> */}
          </div>
        </div>

        <div className='border-t border-border mt-8 pt-8 text-center'>
          <p className='text-sm text-muted-foreground'>
            © 2025 Dr. med. Christine Schrammek Kosmetik. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
